/**
 * contains the abi and contract address
*/

class FoldersContract {
    constructor() {
        this.abi = [
	{
		"constant": false,
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "foldersHash",
				"type": "bytes32"
			}
		],
		"name": "foldersUpdated",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "constructor"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "user",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "foldersHash",
				"type": "bytes32"
			}
		],
		"name": "FoldersUpdated",
		"type": "event"
	}
        ];
        this.contractAddress = '0x20039b89449aC0bAB5B4114Bf66aCff1b3043988';
    }

    getContract(web3) {
        return new web3.eth.Contract(this.abi, this.contractAddress);
    }
}

export default FoldersContract;
